import { BaseComponent } from '../../../../components/BaseComponent';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { HBox, VBox } from '../../../../components/Box';
import { Dropdown } from '../../../../components/Dropdown';
import { Modal, ModalControls } from '../../../../components/Modal';
import { FormField, FormFields } from '../../../../components/FormFields';
import { Input } from '../../../../components/Form';
import { Plus, Times } from '../../../../components/Icon';
import { Button } from '../../../../components/Buttons';
import { ProductSubjectDetails } from '../../../products/components/ProductSubjectDetails';
import { VehicleSelection } from '../VehicleSelection';
import { SubjectVatForm } from './SubjectVatForm';
import { calculateFinancialAmounts } from '../../actions';
import { selectInvoice } from '../../selectors';
import { selectConfig, selectWork } from '../../../Api/selectors';
import { formatAmount } from '../../../Vehicles/helpers';
import {
  BtwOrMarge,
  IncomingCostTypes,
  INVOICE_DIRECTIONS,
  INVOICE_SUBJECT_TYPES,
  OutgoingCostTypes,
  REQUEST_AMOUNTS_CALCULATIONS,
} from '../../constants';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import {ProductDefaultTasksModalConfirmation} from "../../../products/components/productDefaultTasksModal";

const STATE = {
  vehicleEdit: false,
  vehicle: null,
  selectedVehicle: null,
  subjectType: null,
  id: null,
  description: '',
  price: null,
  economicalPrice: null,
  discount: null,
  exclVatBpm: null,
  rest_bpm: null,
  outgoing_rest_bpm: null,
  exclVat: false,
  vatCode: null,
  btwOrMarge: null,
  costType: IncomingCostTypes.CUSTOM_INPUT,
  disableSave: false,
  showDefaultTasksModal: false,
  applyDefaultTasks: false,
};

const Container = styled.div``;

const Wrap = styled.div`
  width: 100%;
  .basic-multi-select {
    width: 100%;
  }
`;

class InvoiceSubjectFormComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE, ...props.subject });
  }

  needToShowDefaultTasksConfirmation(product) {
    return (
      this.props.direction === INVOICE_DIRECTIONS.OUTGOING &&
      !!this.props.vehicleId &&
      !!product.productTasks.length
    );
  }


  onConfirmTasksModalConfirmation(product) {
    this.setState({ applyDefaultTasks: true, showDefaultTasksModal: false });
  }

  onCancelTasksModalConfirmation(product) {
    this.setState({ applyDefaultTasks: false, showDefaultTasksModal: false });
  }

  get subjectOptions() {
    if (INVOICE_DIRECTIONS.INCOMING === this.props.direction) {
      return [
        { value: INVOICE_SUBJECT_TYPES.COST, label: INVOICE_SUBJECT_TYPES.COST },
        { value: INVOICE_SUBJECT_TYPES.PRODUCT, label: INVOICE_SUBJECT_TYPES.PRODUCT },
      ];
    }
    let options = [
      { value: INVOICE_SUBJECT_TYPES.VEHICLE, label: INVOICE_SUBJECT_TYPES.VEHICLE },
      { value: INVOICE_SUBJECT_TYPES.COST, label: INVOICE_SUBJECT_TYPES.COST },
      { value: INVOICE_SUBJECT_TYPES.BPM, label: INVOICE_SUBJECT_TYPES.BPM },
      { value: INVOICE_SUBJECT_TYPES.PRODUCT, label: INVOICE_SUBJECT_TYPES.PRODUCT },
    ];

    if (this.props.serverConfig?.disableBPM) options = options.filter(o => o.value !== INVOICE_SUBJECT_TYPES.BPM);

    return options;
  }

  get btwOrMargeOptions() {
    return [
      { value: BtwOrMarge.BTW, label: BtwOrMarge.BTW },
      { value: BtwOrMarge.MARGE, label: BtwOrMarge.MARGE },
    ];
  }

  get getCostTypeOptions() {
    if (INVOICE_DIRECTIONS.OUTGOING === this.props.direction) {
      return Object.entries(OutgoingCostTypes).map(([key, value]) => {
        return { value, label: value };
      });
    }

    return Object.entries(IncomingCostTypes).map(([key, value]) => {
      return { value, label: value };
    });
  }

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }

  get vatCodeOptions() {
    return this.vatCodes.map(vatCode => {
      return { value: vatCode.code, label: `${vatCode.code} : ${vatCode.description}` };
    });
  }

  onCostTypeChange(evt) {
    const { value } = evt;
    this.setState(
      prev => {
        return { ...prev, costType: value, description: value };
      },
      () => this.handleCalculateInputChange('costType'),
    );
  }

  onExclVatChanged() {
    this.setState(prev => {
      return { ...prev, exclVat: !prev.exclVat };
    });
  }

  onSubjectVatChange(name, value) {
    this.setState(
      prev => {
        const subjectVat = { ...(prev.subjectVat ?? {}), [name]: value };
        return { ...prev, subjectVat, disableSave: true };
      },
      () => this.handleCalculateInputChange('vatCode'),
    );
  }

  descriptionField() {
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.description')}</p>
        <FormField>
          <input
            className="form-control"
            type="textarea"
            name="description"
            value={this.state.description ?? ''}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
      </VBox>
    );
  }

  cost_price_excl_vatField() {
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.cost_price_excl_vat')}</p>
        <FormField>
          <input
            className="form-control"
            disabled={true}
            type="textarea"
            name="cost_price_excl_vat"
            value={this.state.cost_price_excl_vat ?? ''}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
      </VBox>
    );
  }

  bpm_price_excl_vatField() {
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.bpm_price_excl_vat')}</p>
        <FormField>
          <input
            className="form-field"
            disabled={true}
            type="textarea"
            name="bpm_price_excl_vat"
            value={this.state.bpm_price_excl_vat ?? ''}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
      </VBox>
    );
  }

  bpm_marge_priceField() {
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.bpm_marge_price')}</p>
        <FormField>
          <input
            className="form-field"
            disabled={true}
            type="textarea"
            name="bpm_marge_price"
            value={this.state.bpm_marge_price ?? ''}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
      </VBox>
    );
  }

  price_excl_vat_excl_bpmField() {
    if (this.props.direction === INVOICE_DIRECTIONS.INCOMING) {
      return (
        <VBox>
          <p>{this.lbl('invoice.subject.purchase_price_excl_vat_excl_bpm')}</p>
          <FormField>
            <input
              className="form-field"
              disabled={true}
              type="textarea"
              name="financial_purchase_price_excl_vat_excl_bpm"
              value={this.state.financial_purchase_price_excl_vat_excl_bpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
      );
    }

    if (this.props.direction === INVOICE_DIRECTIONS.OUTGOING) {
      return (
        <VBox>
          <p>{this.lbl('invoice.subject.price_excl_vat_excl_bpm')}</p>
          <FormField>
            <input
              className="form-field"
              disabled={true}
              type="textarea"
              name="financial_price_excl_vat_excl_bpm"
              value={this.state.financial_price_excl_vat_excl_bpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
      );
    }

    return '';
  }

  financial_purchase_price_marge_excl_bpmField() {
    if (this.props.direction === INVOICE_DIRECTIONS.INCOMING) {
      return (
        <VBox>
          <p>{this.lbl('invoice.subject.purchase_price_marge_excl_bpm')}</p>
          <FormField>
            <input
              className="form-field"
              type="textarea"
              disabled={true}
              name="financial_purchase_price_marge_excl_bpm"
              value={this.state.financial_purchase_price_marge_excl_bpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
      );
    }

    if (this.props.direction === INVOICE_DIRECTIONS.OUTGOING) {
      return (
        <VBox>
          <p>{this.lbl('invoice.subject.price_marge_excl_bpm')}</p>
          <FormField>
            <input
              className="form-field"
              type="textarea"
              disabled={true}
              name="financial_price_marge_excl_bpm"
              value={this.state.financial_price_marge_excl_bpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
      );
    }

    return '';
  }

  restBpmField() {
    if (this.props.direction === INVOICE_DIRECTIONS.INCOMING) {
      return (
        <VBox>
          <p>{this.lbl('invoice.subject.rest_bpm')}</p>
          <FormField>
            <input
              className="form-field"
              type="textarea"
              name="rest_bpm"
              value={this.state.rest_bpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
      );
    }

    if (this.props.direction === INVOICE_DIRECTIONS.OUTGOING) {
      return (
        <VBox>
          <p>{this.lbl('invoice.subject.rest_bpm')}</p>
          <FormField>
            <input
              className="form-field"
              type="textarea"
              name="outgoing_rest_bpm"
              value={this.state.outgoing_rest_bpm ?? ''}
              onChange={this.onInputChange.bind(this)}
            />
          </FormField>
        </VBox>
      );
    }

    return '';
  }

  grossBpmField() {
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.gross_bpm')}</p>
        <FormField>
          <input
            className="form-field"
            type="textarea"
            name="rest_bpm"
            value={this.props.subject?.financial_bpm_gross ?? ''}
            disabled={true}
          />
        </FormField>
      </VBox>
    );
  }

  btwOrMargeField() {
    const disabled = this.state.type === INVOICE_SUBJECT_TYPES.VEHICLE;
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.btwOrMarge')}</p>
        <Dropdown
          disabled={disabled}
          options={this.btwOrMargeOptions}
          value={this.state.btwOrMarge}
          onChange={this.onBtwOrMargeChange.bind(this)}
        />
      </VBox>
    );
  }

  priceField() {
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.price')}</p>
        <FormField>
          <input
            className="form-field"
            name="price"
            value={this.state.price ?? ''}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
      </VBox>
    );
  }

  economicalPriceField() {
    if (this.props.direction === INVOICE_DIRECTIONS.INCOMING) return;
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.economicalPrice')}</p>
        <FormField>
          <input
            className="form-field"
            name="economicalPrice"
            value={this.state.economicalPrice ?? ''}
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
      </VBox>
    );
  }

  costTypeField() {
    return (
      <VBox>
        <p>{this.lbl('invoice.subject.costType')}</p>
        <Dropdown
          options={this.getCostTypeOptions}
          value={this.state.costType}
          onChange={this.onCostTypeChange.bind(this)}
        />
      </VBox>
    );
  }

  renderCostTypeFields() {
    return (
      <React.Fragment>
        {this.costTypeField()}
        {this.descriptionField()}
        {this.cost_price_excl_vatField()}
        <SubjectVatForm subjectVat={this.state.subjectVat} onChange={this.onSubjectVatChange.bind(this)} />
        <HBox>
          {this.priceField()}
          {this.economicalPriceField()}
        </HBox>
      </React.Fragment>
    );
  }

  renderBpmFields() {
    return (
      <React.Fragment>
        {this.btwOrMargeField()}
        {this.renderBPMFieldsUnderTaxTypeSection()}
      </React.Fragment>
    );
  }

  renderBPMFieldsUnderTaxTypeSection() {
    if (!this.state.btwOrMarge) return '';
    if (this.state.btwOrMarge === BtwOrMarge.BTW) {
      return this.renderBPMBtwFields();
    } else {
      return this.renderBPMMargeFields();
    }
  }

  renderBPMBtwFields() {
    return (
      <React.Fragment>
        {this.descriptionField()}
        <HBox>{this.grossBpmField()}</HBox>
        <HBox>{this.bpm_price_excl_vatField()}</HBox>
        <SubjectVatForm subjectVat={this.state.subjectVat} onChange={this.onSubjectVatChange.bind(this)} />
        <HBox>
          {this.priceField()}
          {this.economicalPriceField()}
        </HBox>
      </React.Fragment>
    );
  }

  renderBPMMargeFields() {
    return (
      <React.Fragment>
        {this.descriptionField()}
        <HBox>{this.bpm_marge_priceField()}</HBox>
        <HBox>
          {this.priceField()}
          {this.economicalPriceField()}
        </HBox>
      </React.Fragment>
    );
  }

  renderVehicleSubjectFields() {
    return (
      <React.Fragment>
        {this.renderVehicleEdit()}
        <VBox>
          <p>{this.lbl('invoice.subject.vehicle')}</p>
          <FormField>{this.renderVehicle()}</FormField>
        </VBox>
        <HBox>{this.btwOrMargeField()}</HBox>
        {this.renderVehicleFieldsUnderTaxTypeSection()}
      </React.Fragment>
    );
  }

  renderVehicleFieldsUnderTaxTypeSection() {
    if (!this.state.btwOrMarge) return '';
    if (this.state.btwOrMarge === BtwOrMarge.BTW) {
      return this.renderVehicleBtwFields();
    } else {
      return this.renderVehicleMargeFields();
    }
  }

  renderVehicleBtwFields() {
    return (
      <React.Fragment>
        {this.descriptionField()}
        <HBox>{this.price_excl_vat_excl_bpmField()}</HBox>
        {!this.props.serverConfig?.disableBPM && (
          <HBox>
            {this.restBpmField()}
            {this.grossBpmField()}
          </HBox>
        )}
        <SubjectVatForm subjectVat={this.state.subjectVat} onChange={this.onSubjectVatChange.bind(this)} />
        <HBox>
          {this.priceField()}
          {this.economicalPriceField()}
        </HBox>
      </React.Fragment>
    );
  }

  renderVehicleMargeFields() {
    return (
      <React.Fragment>
        {this.descriptionField()}
        <HBox>{this.financial_purchase_price_marge_excl_bpmField()}</HBox>
        {!this.props.serverConfig?.disableBPM && (
          <HBox>
            {this.restBpmField()}
            {this.grossBpmField()}
          </HBox>
        )}
        <HBox>
          {this.priceField()}
          {this.economicalPriceField()}
        </HBox>
      </React.Fragment>
    );
  }

  get taxRegion() {
    return this.props?.invoice?.taxRegion;
  }

  renderProductModal() {
    return (
      <ProductSubjectDetails
        editMode={this.props.subject?.id}
        subjectModal
        invoice={this.props.invoice}
        vehicle={this.props.vehicle}
        vehicleId={this.props.vehicleId}
        onClose={this.onClose.bind(this)}
        currentSubject={this.props.subject}
        companyId={this.props.invoice?.companyForAccounting?.id}
        taxRegion={this.taxRegion}
        vehiclePurpose={this.props.vehiclePurpose}
        subjectOptions={this.subjectOptions}
        type={this.state.type}
        onChangeSubjectType={this.onSubjectTypeChange.bind(this)}
      />
    );
  }

  renderVehicle() {
    if (this.state.vehicle) {
      return (
        <HBox>
          <p>{this.state.vehicle.id ?? ''}</p>

          <Times onClick={this.onResetVehicle.bind(this)} />
        </HBox>
      );
    }

    return <Plus onClick={this.onEditVehicle.bind(this)} />;
  }

  onResetVehicle() {
    this.updateState('vehicle', null);
  }

  onEditVehicle() {
    this.updateState('vehicleEdit', true);
  }

  renderVehicleEdit() {
    if (!this.state.vehicleEdit) return '';
    return (
      <ModalComponent title={this.lbl('confirm')} onClose={this.closeVehicleEdit.bind(this)}>
        {this.state.selectedVehicle ? (
          <VBox>{this.state.selectedVehicle.id}</VBox>
        ) : (
          <VehicleSelection onSelect={this.onChangeVehicleSelection.bind(this)} />
        )}
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent style="ButtonSoftEdit" onClick={this.onChangeVehicle.bind(this)}>
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.closeVehicleEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  onChangeVehicleSelection(vehicle) {
    const description = `${vehicle.brand_name} ${vehicle.model_name} (${vehicle.vin})`;
    const price = vehicle.financial_price_b2b_incl_vat_btpm ?? 0;
    this.setState(prev => {
      return {
        ...prev,
        selectedVehicle: vehicle,
        description,
        price,
      };
    });
  }

  closeVehicleEdit() {
    this.updateState('vehicleEdit', false);
  }

  // onChangeVehicle() {
  //   this.setState(prev => {
  //     return {
  //       ...prev,
  //       vehicle: prev.selectedVehicle,
  //       vehicleEdit: false,
  //       selectedVehicle: null,
  //     };
  //   })
  // }

  get dto() {
    const subject = {
      id: this.state.id,
      type: this.state.type,
      saved: this.state.saved,
      description: this.state.description,
      price: this.state.price,
      economicalPrice: this.state.economicalPrice,
      subjectVat: this.state.subjectVat,
      financial_purchase_price_marge_bpm: this.state.financial_purchase_price_marge_bpm ?? null,
      financial_purchase_price_marge_excl_bpm: this.state.financial_purchase_price_marge_excl_bpm ?? null,
      financial_purchase_price_incl_vat_bpm: this.state.financial_purchase_price_incl_vat_bpm ?? null,
      financial_purchase_price_incl_vat_excl_bpm: this.state.financial_purchase_price_incl_vat_excl_bpm ?? null,
      financial_purchase_price_excl_vat_excl_bpm: this.state.financial_purchase_price_excl_vat_excl_bpm ?? null,
      outgoing_rest_bpm: this.state.outgoing_rest_bpm ?? null,
      financial_price_incl_vat_bpm: this.state.financial_price_incl_vat_bpm ?? null,
      financial_price_incl_vat_excl_bpm: this.state.financial_price_incl_vat_excl_bpm ?? null,
      financial_price_excl_vat_excl_bpm: this.state.financial_price_excl_vat_excl_bpm ?? null,
      financial_price_marge_excl_bpm: this.state.financial_price_marge_excl_bpm ?? null,
      financial_price_marge_incl_bpm: this.state.financial_price_marge_incl_bpm ?? null,
      cost_price_excl_vat: this.state.cost_price_excl_vat ?? null,
      cost_price_incl_vat: this.state.cost_price_incl_vat ?? null,
      bpm_price_excl_vat: this.state.bpm_price_excl_vat ?? null,
      bpm_price_incl_vat: this.state.bpm_price_incl_vat ?? null,
      bpm_marge_price: this.state.bpm_marge_price ?? null,
      rest_bpm: this.state.rest_bpm ?? null,
    };

    if (INVOICE_SUBJECT_TYPES.VEHICLE === this.state.type) {
      subject.costType = this.state.costType;
      subject.restBpm = this.state.restBpm;
      subject.btwOrMarge = this.state.btwOrMarge;
    }

    if (INVOICE_SUBJECT_TYPES.COST === this.state.type) {
      subject.costType = this.state.costType;
    }

    if (INVOICE_SUBJECT_TYPES.PRODUCT === this.state.type) {
      subject.applyDefaultTasks = this.state.applyDefaultTasks;
    }

    Object.entries(subject).forEach(([key, value]) => {
      subject[key] = this.sanitizeValue(value);
    });

    return subject;
  }

  get financialAmountsDto() {
    const subject = {
      id: this.state.id,
      subject_type: this.state.type,
      costType: this.state.costType,
      saved: this.state.saved,
      description: this.state.description,
      economicalPrice: this.state.economicalPrice,
      subjectVat: this.state.subjectVat,
      vatCode: this.state.subjectVat?.code,
      direction: this.props.direction,
      incomingCompanyId: this.props.incomingCompanyId,
      outgoingCompanyId: this.props.outgoingCompanyId,
      financialAmounts: {
        financial_purchase_price_marge_bpm: this.state.price ?? null,
        financial_purchase_price_marge_excl_bpm: null,
        financial_purchase_price_incl_vat_bpm: this.state.price ?? null,
        financial_purchase_price_incl_vat_excl_bpm: null,
        financial_purchase_price_excl_vat_excl_bpm: null,
        financial_price_marge_incl_bpm: this.state.price ?? null,
        outgoing_rest_bpm: this.state.outgoing_rest_bpm ?? null,
        financial_price_incl_vat_bpm: this.state.price ?? null,
        financial_price_incl_vat_excl_bpm: null,
        financial_price_excl_vat_excl_bpm: null,
        financial_price_marge_excl_bpm: null,
        cost_price_excl_vat: null,
        cost_price_incl_vat: this.state.price ?? null,
        bpm_price_excl_vat: null,
        bpm_price_incl_vat: this.state.price ?? null,
        bpm_marge_price: this.state.price ?? null,
        rest_bpm: this.state.rest_bpm ?? null,
      },
      salesAmounts: {
        outgoing_rest_bpm: this.state.outgoing_rest_bpm ?? null,
        financial_price_incl_vat_bpm: this.state.price ?? null,
        financial_price_incl_vat_excl_bpm: null,
        financial_price_excl_vat_excl_bpm: null,
        financial_price_marge_excl_bpm: null,
        cost_price_excl_vat: null,
        cost_price_incl_vat: this.state.price ?? null,
        bpm_price_excl_vat: null,
        bpm_price_incl_vat: this.state.price ?? null,
        bpm_marge_price: this.state.price ?? null,
        financial_price_marge_incl_bpm: this.state.price ?? null,
      },
      isBrutoScenario: this.props.isBrutoScenario,
    };

    if (subject.direction === INVOICE_DIRECTIONS.INCOMING) {
      subject.salesAmounts = {};
    }

    if (INVOICE_SUBJECT_TYPES.VEHICLE === this.state.type) {
      subject.costType = this.state.costType;
      subject.tax_type = this.state.btwOrMarge;
      subject.vehicleId = this.state.vehicle?.id ?? null;
    }

    if (INVOICE_SUBJECT_TYPES.COST === this.state.type) {
      subject.costType = this.state.costType;
    }

    Object.entries(subject).forEach(([key, value]) => {
      subject[key] = this.sanitizeValue(value);
    });

    Object.entries(subject.financialAmounts).forEach(([key, value]) => {
      subject.financialAmounts[key] = this.sanitizeValue(value);
    });

    return subject;
  }

  onSave() {
    this.props.onSaveSubject(this.dto);
  }

  sanitizeValue(raw) {
    return raw === '' ? null : raw;
  }

  onClose() {
    this.props.onClose();
  }

  onInputChange(evt) {
    const name = evt?.target?.name;
    const value = evt?.target?.value;
    if (!name) return;
    this.setState(
      prev => {
        return { ...prev, [name]: value, disableSave: true };
      },
      () => this.handleCalculateInputChange(name),
    );
  }

  handleCalculateInputChange(name) {
    if (['price', 'rest_bpm', 'outgoing_rest_bpm', 'vatCode', 'costType'].includes(name)) {
      this._t = this.timeout(this.calculateFinancialAmounts.bind(this), 1000, this._t);
    }
  }

  onSubjectTypeChange(evt) {
    const { value } = evt;
    this.setState(
      prev => {
        return { ...prev, type: value, disableSave: true };
      },
      () => {
        if (this.state.type === INVOICE_SUBJECT_TYPES.COST) {
          this._t = this.timeout(this.calculateFinancialAmounts.bind(this), 100, this._t);
        }
      },
    );
  }

  onBtwOrMargeChange(evt) {
    const { value } = evt;
    this.setState(
      prev => {
        return { ...prev, btwOrMarge: value, disableSave: true };
      },
      () => {
        if (this.state.type === INVOICE_SUBJECT_TYPES.BPM || this.state.type === INVOICE_SUBJECT_TYPES.VEHICLE) {
          this._t = this.timeout(this.calculateFinancialAmounts.bind(this), 100, this._t);
        }
      },
    );
  }

  onChangeVehicle() {
    this.setState(
      prev => {
        return {
          ...prev,
          vehicle: prev.selectedVehicle,
          vehicleEdit: false,
          selectedVehicle: null,
          disableSave: true,
        };
      },
      () => {
        if (this.state.vehicle?.id) {
          this._t = this.timeout(this.calculateFinancialAmounts.bind(this), 100, this._t);
        }
      },
    );
  }

  calculateFinancialAmounts() {
    this.props.calculateFinancialAmounts(this.financialAmountsDto, result => {
      if (result?.id) {
        delete result.id;
      }

      if (result?.invoiceId) {
        delete result?.invoiceId;
      }

      if (result?.subjectVat?.id) {
        delete result.subjectVat.id;
      }

      delete result.costType;
      this.setState(prev => {
        return { ...prev, ...result, disableSave: false };
      });
    });
  }

  renderSuitableFields() {
    switch (this.state.type) {
      case INVOICE_SUBJECT_TYPES.VEHICLE:
        return this.renderVehicleSubjectFields();
      case INVOICE_SUBJECT_TYPES.COST:
        return this.renderCostTypeFields();
      case INVOICE_SUBJECT_TYPES.BPM:
        return this.renderBpmFields();
      case INVOICE_SUBJECT_TYPES.PRODUCT:
        return this.renderProductModal();
      default:
        return <React.Fragment></React.Fragment>;
    }
  }

  render() {
    return (
      <Container>
        {this.state.type === INVOICE_SUBJECT_TYPES.PRODUCT ? (
          <>
            {this.state.showDefaultTasksModal && <ProductDefaultTasksModalConfirmation
              onConfirm={this.onConfirmTasksModalConfirmation.bind(this)}
              onCancel={this.onCancelTasksModalConfirmation.bind(this)}
            />}
            {this.renderSuitableFields()}
          </>
        ) : (
          <ModalComponent title={this.lbl('invoice.subject.title')} onClose={this.onClose.bind(this)}>
            <FormFields>
              <VBox>
                <p>{this.lbl('invoice.subject.type')}</p>
                <Wrap>
                  <SearchSelect
                    options={this.subjectOptions}
                    value={this.state.type}
                    onChange={this.onSubjectTypeChange.bind(this)}
                  />
                </Wrap>
              </VBox>
              {this.renderSuitableFields()}
            </FormFields>
            <div className="mt-2 d-flex gap-2">
              <ButtonComponent
                style="ButtonSoftEdit"
                disabled={this.state.disableSave || !!this.props.work}
                onClick={this.onSave.bind(this)}
              >
                {this.lbl('save')}
              </ButtonComponent>
              <ButtonComponent style="ButtonSoftDelete" onClick={this.onClose.bind(this)}>
                {this.lbl('cancel')}
              </ButtonComponent>
            </div>
          </ModalComponent>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(),
    work: selectWork(REQUEST_AMOUNTS_CALCULATIONS),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    calculateFinancialAmounts(subject, callback) {
      subject = formatFinancialAmounts(subject);
      dispatch(calculateFinancialAmounts(subject, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceSubjectForm = compose(withConnect, withRouter)(InvoiceSubjectFormComp);

const formatFinancialAmounts = function(input) {
  if (input?.financialAmounts) {
    for (let key in input.financialAmounts) {
      if (typeof input.financialAmounts[key] !== 'number' && input.financialAmounts[key]?.includes(',')) {
        input.financialAmounts[key] = formatAmount(input.financialAmounts[key]);
      }
    }
  }

  if (input?.salesAmounts) {
    for (let key in input.salesAmounts) {
      if (typeof input.salesAmounts[key] !== 'number' && input.salesAmounts[key]?.includes(',')) {
        input.salesAmounts[key] = formatAmount(input.salesAmounts[key]);
      }
    }
  }

  return input;
};
